export const CssClass = {
  error: 'error'
}
